document.addEventListener('DOMContentLoaded', () => {
  const countdown = document.querySelector('sale-timer-countdown');
  if (!countdown) return;

  const section = countdown.closest('.sale-timer-section');
  const saleTimerDiv = countdown.closest('.sale-timer');
  const isInMain = document.getElementById('main')?.contains(countdown);

  if (isInMain && section) {
    section.classList.add('is-top-section');
  }

  let interval = null;
  let isShown = false;

  const syncTimerHeight = () => {
    const isHidden = (section ?? saleTimerDiv)?.classList.contains('hidden');
    const height = isHidden ? 0 : countdown.offsetHeight;
    document.documentElement.style.setProperty('--sale-timer-height', `${height}px`);
  };

  const ro = new ResizeObserver(syncTimerHeight);
  ro.observe(countdown);

  const hideSection = () => {
    isShown = false;
    (section ?? saleTimerDiv)?.classList.add('hidden');
    syncTimerHeight();
  };

  const showSection = () => {
    if (isShown) return;
    isShown = true;
    saleTimerDiv?.classList.remove('hidden');
    section?.classList.remove('hidden');
    countdown.classList.remove('invisible');
    syncTimerHeight();
  };

  const endDateStr = countdown.dataset.endDate?.trim();
  if (!endDateStr) {
    showSection();
    return;
  }

  const endDate = new Date(endDateStr);
  if (isNaN(endDate.getTime())) {
    showSection();
    return;
  }

  const startDateStr = countdown.dataset.startDate?.trim();
  const startDate = startDateStr && !isNaN(new Date(startDateStr).getTime())
    ? new Date(startDateStr)
    : null;

  const unitsContainer = countdown.querySelector('[data-timer-units]');
  const daysUnit = countdown.querySelector('[data-timer-unit="days"]');
  const numbers = {
    days: countdown.querySelector('[data-timer-number="days"]'),
    hours: countdown.querySelector('[data-timer-number="hours"]'),
    minutes: countdown.querySelector('[data-timer-number="minutes"]'),
    seconds: countdown.querySelector('[data-timer-number="seconds"]'),
  };

  const tick = () => {
    const diff = endDate - Date.now();

    if (diff <= 0) {
      clearInterval(interval);
      hideSection();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    daysUnit.classList.toggle('hidden', days === 0);
    daysUnit.classList.toggle('flex', days !== 0);
    numbers.days.textContent = String(days).padStart(2, '0');
    numbers.hours.textContent = String(hours).padStart(2, '0');
    numbers.minutes.textContent = String(minutes).padStart(2, '0');
    numbers.seconds.textContent = String(seconds).padStart(2, '0');
    unitsContainer.classList.remove('hidden');
    unitsContainer.classList.add('flex');

    showSection();
  };

  const startCountdown = () => {
    tick();
    if (isShown) {
      interval = setInterval(tick, 1000);
    }
  };

  const now = Date.now();

  if (startDate && now < startDate.getTime()) {
    setTimeout(startCountdown, startDate.getTime() - now);
  } else {
    startCountdown();
  }
});
